module.exports = __webpack_public_path__ + "img/396ab90.png";